import moon from 'assets/logo/Moon.svg'
import LoadingMoon from 'assets/logo/loadingMoon.png'
import biddingUp from 'assets/icons/bidup_icon-simple.svg'
import biddingDown from 'assets/icons/biddown_icon-simple.svg'
import nftGreenCoin from 'assets/icons/yolo_nft-emerald.png'
import nftBlueCoin from 'assets/icons/yolo_nft-blue.svg'
import bidUpFlag from 'assets/icons/bid_up_icon.svg'
import bidDownFlag from 'assets/icons/bid_down_icon.svg'
import liveText from 'assets/icons/live_text.svg'
import YoloTokenIcon from 'assets/icons/yolo_token_icon.svg'
import YoloTokenStacked3d from 'assets/icons/yolorekt_logo-stacked-3D.svg'

import nftSilver from 'assets/icons/yolo_nft-silver.png'
import nftOrchid from 'assets/icons/yolo_nft-orchid.png'
import nftEmerald from 'assets/icons/yolo_nft-emerald.png'
import nftGold from 'assets/icons/yolo_nft-gold.png'
import nftRuby from 'assets/icons/yolo_nft-ruby.png'
import nftDiamond from 'assets/icons/yolo_nft-diamond.png'
import bidDownSuccess from 'assets/icons/bid_down_success_icon.svg'
import bidUpSuccess from 'assets/icons/bid_up_success_icon.svg'
import bid24Success from 'assets/icons/bid_24_success_icon.svg'

export const yolorekt = {
  moon,
  LoadingMoon,
  biddingUp,
  biddingDown,
  nftGreenCoin,
  nftBlueCoin,
  bidUpFlag,
  bidDownFlag,
  liveText,
  YoloTokenIcon,
  nftSilver,
  nftOrchid,
  nftEmerald,
  nftGold,
  nftRuby,
  nftDiamond,
  YoloTokenStacked3d,
  bidDownSuccess,
  bidUpSuccess,
  bid24Success,
}
